import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { Ausentismos } from '../../../../models/ausentismos';
import { AusentismosService } from '../../../../services/ausentismos.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-ausentismos-list',
  templateUrl: './ausentismos-list.component.html',
  styleUrls: ['./ausentismos-list.component.css']
})
export class AusentismosListComponent implements OnInit
{

  @Input() personalId: number;
  @Input() ausentismos: Ausentismos[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<Ausentismos>();

  ausentismosOri: Ausentismos[];
  ausentismosGrupo: Ausentismos[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private ausentismoService: AusentismosService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.ausentismosOri = this.ausentismos;
    this.inicializaFiltros();
    
    this.filtrarContingentes();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarContingentes()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.ausentismos = this.ausentismosOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.ausentismosGrupo == undefined)
      {
        this.ausentismoService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
            });

            this.ausentismosGrupo = data;
            this.ausentismos = this.ausentismosGrupo;
          });

      } else
      {
        this.ausentismos = this.ausentismosGrupo;
      }
      
    } else
    {
      this.filtrarContingentes();
    }
  }

  onChangeFiltros()
  {
    this.filtrarContingentes();
  }

  visualizarDetalle(ausentismo)
  {
    this.VisualizarDetalle.emit(ausentismo);
  }

  add()
  {
    let ausentismo: Ausentismos = { id: 0, personal: this.personalId, desde: new Date().toString(), hasta: new Date().toString(), claseAusentismo: 0, cantidad: 0};
    this.VisualizarDetalle.emit(ausentismo);
  }
}
